module.exports = __webpack_public_path__ + "static/img/M2-S-328-1.6095ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module2/M2-S-328-1.png
// module id = 661
// module chunks = 0